export default __webpack_public_path__ + "static/media/IMG_2352.c231410e.jpg";